import {
  IShow,
  ISupplierCompany,
  ISupplierCompanyToProductCategory,
  IProductToCategory,
} from "@evennt-tech/api-v2-core";

export const getCategoryCode = (
  categories: Pick<IProductToCategory, "mainCategoryId">[],
  supplierCategoryCodes: ISupplierCompanyToProductCategory[]
) => {
  const categoryId = categories?.[0]?.mainCategoryId;
  if (!categoryId) return undefined;

  const categoryCode = supplierCategoryCodes.find(
    (code) => code.productCategoryId === categoryId
  );

  return categoryCode?.overrideProductCategoryCode;
};

const generateMergedProjectCode = (
  projectCode: string | undefined,
  categoryCode: string | undefined
): string => {
  return [projectCode, categoryCode].filter(Boolean).join("-");
};

type GetMergedProjectCodeArgs = {
  categories: Pick<IProductToCategory, "mainCategoryId">[];
  show: IShow;
  supplierCompany?: ISupplierCompany;
  optionProjectCodes?: string[];
  supplierCategoryCodes: ISupplierCompanyToProductCategory[];
};

export const getMergedProjectCode = ({
  categories,
  show,
  supplierCompany,
  supplierCategoryCodes,
}: GetMergedProjectCodeArgs) => {
  if (!supplierCompany) {
    return;
  }

  const categoryCode = getCategoryCode(categories || [], supplierCategoryCodes);

  const productCode = generateMergedProjectCode(
    show?.projectCode,
    categoryCode
  );

  return productCode;
};
